import { BsPinAngle } from "react-icons/bs";

function OwnerReview({ name, src, color, discription }) {

  return (
    <div className="flex justify-center items-center py-12 px-6 ">
      <div className="flex flex-col md:flex-row bg-gray-200 shadow-xl rounded-3xl p-6 md:p-10 max-w-5xl w-full border-l-8 border-primary/70">
        {/* Left - Image Section */}
        <div className={`flex-shrink-0 flex justify-center md:justify-start ${src ? "md:w-1/3 w-full" : `w-0`}`}>
          {src && <img
            src={src}
            alt="Shree Amit Thaker"
            className="h-52 w-52 md:h-64 md:w-64 object-cover rounded-xl border-4 border-white shadow-lg"
          />
            // <div className="h-52 w-52 md:h-64 md:w-64 object-cover rounded-xl border-4 border-white shadow-lg flex items-center justify-center bg-secondary/10 text-4xl font-bold" style={{
            //   color: color()
            // }}>
            //   {name.split(" ").map((e) => e.charAt(0)).join("").toUpperCase()}
            // </div>
          }
        </div>

        {/* Right - Content Section */}
        <div className="mt-6 md:mt-0 md:ml-10 flex flex-col justify-center w-full md:w-2/3 text-center md:text-left">
          <h2 className="relative text-2xl md:text-3xl font-bold text-primary">
            {name}
            <p className="absolute top-0 -left-6 rounded-2xl w-1.5 bg-secondary h-24"></p>
          </h2>
          <p className="text-lg text-primary/75 font-medium mt-2">
            A visionary academician with dedication to shaping
            education.
          </p>

          {/* Info List */}
          <div className="mt-4 space-y-2 text-primary/90">
            <p className="flex items-center justify-center md:justify-start">
              <span className="font-semibold mr-2"><BsPinAngle size={20} className="text-secondary" /></span>
              <span>{discription}</span>
            </p>
            {/* <p className="flex items-center justify-center md:justify-start">
              <span className="font-semibold mr-2"><BsPinAngle size={20} className="text-secondary" /></span>
              Government-appointed syndicate member of Gujarat University (2
              terms).
            </p>
            <p className="flex items-center justify-center md:justify-start">
              <span className="font-semibold mr-2"><BsPinAngle size={20} className="text-secondary" /></span>
              Leading role in Akhil Bhartiya Vidyarthi Parishad (ABVP).
            </p>
            <p className="flex items-center justify-center md:justify-start">
              <span className="font-semibold mr-2"><BsPinAngle size={20} className="text-secondary" /></span>
              Board of Governor member at Gujarat Technological University (GTU)
              for 5 years.
            </p> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OwnerReview;
